import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWorld = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M9 0a9 9 0 010 18A9 9 0 119 0zm0 16.88c.03 0 .2-.02.47-.33.28-.32.59-.84.86-1.58.33-.86.58-1.94.74-3.16H6.93c.16 1.22.41 2.3.74 3.16.27.74.58 1.26.86 1.58.28.31.44.32.47.32zm-2.19-6.2a22.64 22.64 0 010-3.37h4.38a22.65 22.65 0 010 3.38H6.8zm5.4 1.13a12.72 12.72 0 01-1.45 4.87 7.9 7.9 0 005.6-4.87H12.2zm4.48-1.12h-4.37a23.8 23.8 0 000-3.38h4.37a7.9 7.9 0 010 3.38zm-11 0H1.3a7.9 7.9 0 010-3.38h4.37a23.81 23.81 0 000 3.38zM1.63 11.8H5.8c.25 2.04.77 3.76 1.45 4.87a7.89 7.89 0 01-5.6-4.87zM6.93 6.2h4.14a14.5 14.5 0 00-.74-3.16 5.15 5.15 0 00-.86-1.58c-.28-.31-.44-.32-.47-.32-.03 0-.2 0-.47.32-.28.32-.59.84-.86 1.58a14.5 14.5 0 00-.74 3.16zm5.28 0h4.15a7.89 7.89 0 00-5.6-4.87c.68 1.1 1.2 2.83 1.45 4.87zM7.24 1.32c-.68 1.1-1.2 2.83-1.45 4.87H1.64a7.9 7.9 0 015.6-4.87z"
	})
});
export default SvgWorld;
